import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

import { ProductVntaService } from './product-vnta.service';

import { Globals } from '../globals';
import { QuotationFunctionData } from '../quotation-activity-functions';

interface ProductionOrder {
    active: number;
    createdAt: any;
    updatedAt: any;

    employeeId?: string;
    longDescription: string;
    name: string;
    date: string;
    projectFolio: number;
    shipId?: string;
    shortDescription: string;

    status: string;
    lastStatus: string;
    quantity: number;
    remittedQuantity: number;
    deliveryDate?: string;
    prClient?: PrClient;
    customer?: Customer;
    prVntaId: string;
    pricePerUnit: number;
    monitor: number;
    pieceType: string;
    notes: string;

    sections: any[];
    generalActivities: any[];
    canceled: boolean;
    cancelReasons: {datetime: string, msg: string}[];
}

export interface ProductionOrderId extends ProductionOrder {
    id: string;
}

export interface PrClient {
    id: string;
    code: string;
    version: string;
    barCode: string;
    designComments?: string;
    qualityComments?: string;
    processOwnerComments?: string;
}
export interface Customer {
    id: string;
    name: string;
    purchaseOrderNumber: string;
    addressId: string;
}
export interface OdpActivity{
  actId: string;
  classification: string;
  dataCalc: number;
  name: string;
  prices: number[];
  quantityPricesFunction: keyof QuotationFunctionData['functionData'];
  ranges: { max: number, min: number, price: number }[];
  unique: any;
  dateEnd: string;
  dateStart: string;
  employeeMade: string;
  employeeProduction: string;
  employeeQuality: string;
  notes: string;
  status: keyof ProductionOrderData['activityStatusObjects'];
  timeEnd: string;
  timeStart: string;
}

@Injectable()
export class ProductionOrderService {
    collection: string;
    companyCollection: string;
    companyId: string;

    constructor(
        private afs: AngularFirestore,
        private afh: FirestoreService,
        private router: Router,
        private prVntaService: ProductVntaService
    ) {
        this.collection = Globals.PRODUCTION_ORDER_COLLECTION;
        this.companyCollection = Globals.COMPANIES_COLLECTION;
        this.companyId = Globals.AGRO_VIVA_DOCUMENT_ID;
    }

    returnFromViewTo: 'default' | 'lite' = 'default';

    postProductionOrder(productionOrderObject: any) {
        //let col = this.afs.collection(this.collection);
        const docId: string = this.afs.createId();
        const objRef = this.afs.collection(this.collection).doc(docId);
        objRef.set({
          ...productionOrderObject,
          active: 1
        });
        return docId;

        //return col.add({...productionOrderObject, active: 1});
    }

    getProductionOrders({filterDays=undefined, date=undefined, onEmpty=undefined, lessStatus=undefined}={}) {
        let col;
        if(filterDays){
            let filteredDate = new Date();
            filteredDate.setDate(filteredDate.getDate() - filterDays);
            let date = this.stringifyDate(filteredDate);
            col = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).where('deliveryDate', '>', date) );
        }else if(lessStatus){
            col = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).where('status', '<', lessStatus) );
        }else if(date){
            col = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).where('date', '>=', date) );
        }else{
            col = this.afs.collection(this.collection, ref => ref.where('active', '==', 1) );
        }


        return col.snapshotChanges().map(actions => {
            if(!actions.length && onEmpty) onEmpty();
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as ProductionOrder;
                //if(!new ProductionOrderData().activityStatusObjects)

                const name = data.name;
                const projectFolio = data.projectFolio;
                const shortDescription = data.shortDescription;
                const status = new ProductionOrderData().statusObjects[data.status].name;
                const statusKey = data.status;
                const quantity = data.quantity;
                const remittedQuantity = data.remittedQuantity;
                const deliveryDate = data.deliveryDate || '';
                const prVntaId = data.prVntaId;
                const pricePerUnit = data.pricePerUnit;

                return { ...data, id$, id: id$, name, projectFolio, shortDescription, status, statusKey, quantity, remittedQuantity, deliveryDate, prClient: data.prClient, customer: data.customer, prVntaId, pricePerUnit };
            });
        }).map(object => object);        
    }

    getProductionOrder(id$: string) {
        return this.afh.docWithIds$(`${this.collection}/${id$}`).map(document => {
            return Observable.combineLatest(
                this.afh.docWithIds$(`${this.companyCollection}/${this.companyId}`),
                (companyData) => ({ company: companyData })
            ).map(data => ({ companyObj: data.company, ...document }) );
        }).mergeMap(documents => Observable.combineLatest(documents));
        /* this.productionOrderDocument = this.afs.doc(this.collection + '/' + id$);

        this.productionOrder = this.productionOrderDocument.valueChanges();

        return this.productionOrder.map(object => object); */
    }

    getLastProductionOrder() {
        let col = this.afs.collection(this.collection, ref => ref.orderBy('projectFolio', 'desc').where('active', '==', 1).limit(1) );

        return col.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as ProductionOrder;

                const projectFolio = data.projectFolio;

                return { id$, projectFolio };
            });
        }).map(object => object);
    }

    putProductionOrder(productionOrderObject: any, id$: string) {
        let col = this.afs.collection(this.collection);

        return col.doc(id$).update(productionOrderObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delProductionOrder(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        let doc = this.afs.doc(this.collection + '/' + id$);
        
        return doc.update({ active: 0, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    windowReplace(action: string, id?: string){
      switch(action){
        case 'add':
        case 'create':
          this.router.navigate([`/add_production_order/${id}`]);
          break;
        case 'edit':
        case 'update':
          this.router.navigate([`/edt_production_order/${id}`]);
          break;
        case 'view':
        case 'display':
          this.router.navigate([`/vw_production_order/${id}`]);
          break;
        case 'read':
          this.router.navigate([`/production_orders`]);
          break;
        case 'liteSearch':
          this.router.navigate([`/odpLiteSearch`]);
          break;
        default:
          console.log('Not an action');
      }
    }

    stringifyDate(date: Date){
      var dd:string = date.getDate() + '';
      var mm:string = date.getMonth()+ 1 + '';
      var yyyy = date.getFullYear();
      if(+dd<10) dd = '0'+dd;
      if(+mm<10) mm = '0'+mm;
      return yyyy + '-' + mm + '-' + dd;
    }

}

export class ProductionOrderData{
    //IN CASE OF ORDER CHANGE,
    //DONT CHANGE KEYS (USED FOR DATABASE), CHANGE INDEX ATTRIBUTE
    statusObjects = {
        'key1': {key: 'key1', index: 1, color: '#254E89', name: 'Espera Iniciar'},
        'key2': {key: 'key2', index: 2, color: '#EEAD00', name: 'En Proceso'},
        'key3': {key: 'key3', index: 3, color: '#45995B', name: 'Terminado'},
        'key4': {key: 'key4', index: 6, color: '#7A7A7A', name: 'En Hold'},
        'key98': {key: 'key98', index: 4, color: '#7A57A0', name: 'Entregado'},
        'key99': {key: 'key99', index: 5, color: '#F72658', name: 'Cancelado'},
    }
    printDataSelector = {
        'key1': {key: 'key1', index: 1, name: 'Trabajo nuevo'},
        'key2': {key: 'key2', index: 2, name: 'Reimpresión'},
        'key3': {key: 'key3', index: 3, name: 'Reimpresión con cambios'},
        'key4': {key: 'key4', index: 4, name: 'Reimpresión por Reproceso'}
    }
    readonly hiloOptions = [
      'Al hilo',
      'Al contrahilo',
    ] as [ 'Al hilo', 'Al contrahilo' ];
    

  //   statusObjects = {
  //     'key1': {key: 'key1', index: 1, color: '#719fcf', name: 'Espera Iniciar'},
  //     'key2': {key: 'key2', index: 2, color: '#faee38', name: 'En Proceso'},
  //     'key3': {key: 'key3', index: 3, color: '#81d41d', name: 'Terminado'},
  //     'key4': {key: 'key4', index: 6, color: '#999999', name: 'En Hold'},
  //     'key98': {key: 'key98', index: 4, color: 'red', name: 'Entregado'},
  //     'key99': {key: 'key99', index: 5, color: 'red', name: 'Cancelado'},
  // }

    defaultActivity = {
        dateStart: '',
        dateEnd: '',
        timeStart: '',
        timeEnd: '',
        employeeMade: '',
        employeeQuality: '',
        employeeProduction: '',
        status: 'wait',
        notes: ''
    }
    
    squadPlacasSelect = ['Una cara', 'Dos caras'];
    spinSelect = ['Vuelta bandera', 'Vuelta campana', 'Sencillo'];
    printDataSelect = ['Trabajo nuevo', 'Reimpresión', 'Reimpresión con cambios', 'Reimpresión por Reproceso'];
    squadTirosSelect = ['Normal', 'Contraria'];
    qualityStatusSelect = ['Aceptado', 'Rechazado'];
    reusabilityNegativosSelect = ['No definido', 'Reutilizado', 'Nuevo'];

    defaultUnique = {
      papel: {prCmpaId: '', prCmpaDescription: '', hilo: this.hiloOptions[0], merma: 0},
      suaje: {suajeDescription: '', machineName: ''},
      placas: {squad: this.squadPlacasSelect[0], spin: this.spinSelect[0]},
      tiros: {machineName: '', printData: this.printDataSelect[0], lastProyect: '', squad: this.squadTirosSelect[0], spin: this.spinSelect[0], sizesToRun: 0, clawMeasures: ''},
      tirosVuelta: {machineName: '', printData: this.printDataSelect[0], lastProyect: '', squad: this.squadTirosSelect[0], spin: this.spinSelect[0], sizesToRun: 0, clawMeasures: ''},
      pegado: {machineName: '', pasteType: '6'},
      barnizSuaje: {machineName: ''},
      negativos: {reusability: this.reusabilityNegativosSelect[0], appliesPlacas: 0, machineName: ''},
    };

    defaultQuality = {
        tiros: {machineName: '', squad: this.squadTirosSelect[0], opsNotes: '', piecePerSize: 0, sizes: 0, sizesToRun: 0, clawMeasures: '', positiveRecord: '', ph: '', alcohol: '', legal: '', correctReps: '', surfaceTemp: '', lineClearance: '', powder: '', status: this.qualityStatusSelect[0], humidity: false, register: false, barCode: false, quantity: 0, mermaQuantity: 0, notes: '', userId: '', densityFront: Array(8).fill(''), densityBack: Array(8).fill('')},
        tirosVuelta: {machineName: '', squad: this.squadTirosSelect[0], opsNotes: '', piecePerSize: 0, sizes: 0, sizesToRun: 0, clawMeasures: '', positiveRecord: '', ph: '', alcohol: '', legal: '', correctReps: '', surfaceTemp: '', lineClearance: '', powder: '', status: this.qualityStatusSelect[0], humidity: false, register: false, barCode: false, quantity: 0, mermaQuantity: 0, notes: '', userId: '', densityFront: Array(8).fill(''), densityBack: Array(8).fill('')},
        suaje: {machineName: '', lineClearance: '', record: '', locks: '', VoBoSample: '', matrixMeasure: '', precut: '', predobles: '', pressure: '', scanner: '', quantity: 0, mermaQuantity: 0, notes: '', userId: ''},
        pegado: {machineName: '', lineClearance: '', parallel: '', rip: '', boxRupture: '', damaged: '', rubberPoint: '', packaging: '', labeled: '', quantity: 0, mermaQuantity: 0, notes: '', userId: ''},
        barnizSuaje: {machineName: '', lineClearance: '', shinePoints: '', lampIntensity: '', healing: '', appearance: '', micronQuantity: 0, positiveRecord: '', sealTest: '', rollerValue: '', bellTemp: '', bandVelocity: '', quantity: 0, mermaQuantity: 0, notes: '', userId: ''},
    }

    activityStatusObjects = {
        'wait': {name: 'Espera iniciar', next: 'process'},
        'process': {name: 'En proceso', next: 'finished'},
        'finished': {name: 'Terminado', next: 'hold'},
        'hold': {name: 'En pausa', next: 'wait'}
    }
}

export class ProductionOrderFilter {
  podData = new ProductionOrderData();

  allRows: any[];

  dateIndex: number;
  customerIndex: number;
  statusIndex: number;

  constructor(allRows: any[], {dateIndex=0,customerIndex=0, statusIndex=0, customerName='Todos'}){
    this.allRows = allRows.sort(({name}, {folio}) => name < folio ? 1 : -1);
    this.dateIndex = dateIndex;
    this.customerIndex = customerIndex;
    this.statusIndex = statusIndex;

    let customers: any = new Set( allRows.map(row => row.customerName) );
    let sortedCustomers = [...customers].sort((it1, it2) => it1 > it2 ? 1 : -1);
    this.customerSelect = ['Todos', ...sortedCustomers].map(name => ({name}) );

    console.log(this.customerSelect)
    if(customerIndex >= this.customerSelect.length) this.customerIndex = 0; /* {
      let cIndex = this.customerSelect.findIndex(({name}) => name == customerName);
      console.log(`Searched for '${customerName}', index: ${cIndex}`);
      this.customerIndex = cIndex < 0 ? 0 : cIndex;
    } */
  }

  get filteredData() {
    return this.allRows
      .filter(({date, deliveryDate}) => {
        let rowDate = new Date(date || deliveryDate);
        let filterDate = new Date();
        let {amount, unit} = this.dateSelect[this.dateIndex];
        switch(unit){
          case 'day': filterDate.setDate(filterDate.getDate() - amount); break;
          case 'month': filterDate.setMonth(filterDate.getMonth() - amount); filterDate.setDate(0); break;
          case 'year': filterDate = new Date(filterDate.getFullYear() - amount, 0); break;
          default: filterDate.setFullYear(2015); break;
        }
        if((!date && !deliveryDate) || rowDate >= filterDate) return 1;
      })
      .filter(({customerName: rowName}) => {
        let {name: filterName} = this.customerSelect[this.customerIndex];
        if(rowName == filterName || filterName == 'Todos') return 1;
      })
      .filter(({status: rowName}) => {
        let {name: filterName} = this.statusSelect[this.statusIndex];
        if(rowName == filterName || filterName == 'Todos') return 1;
      });
  }

  get json(): string {
    return JSON.stringify({
      dateIndex: +this.dateIndex,
      customerIndex: +this.customerIndex,
      statusIndex: +this.statusIndex,
      //customerName: this.customerSelect[+this.customerIndex].name,
    });
  }

  dateSelect = [
    { amount: 15, unit: 'day', name: '15 días' },
    { amount: 0, unit: 'month', name: 'Este mes' },
    { amount: 6, unit: 'month', name: '6 meses' },
    { amount: 0, unit: 'year', name: 'Este año' },
    { amount: 0, unit: 'forever', name: 'Siempre' },
  ];
  customerSelect = [];
  statusSelect = [
      {name: 'Todos'},
      ...Object.keys(this.podData.statusObjects).map(key => this.podData.statusObjects[key] )
  ]
}
